import { trigger, state, transition, style, animate, keyframes } from '@angular/animations';

export const slideInOutAnimation =
  // trigger name for attaching this animation to an element using the [@triggerName] syntax
  trigger('slideInOutAnimation', [

      // end state styles for route container (host)
      state('*', style({
          // the view covers the whole screen with a semi tranparent background
          position: 'absolute',
          width: '100%',
          height: '100%'
      })),

      // route 'enter' transition
      transition(':enter', [

          // styles at start of transition
          style({
              transform: 'translateX(-100%)'
          }),

          // animation and styles at end of transition
          animate('.5s ease-in-out', keyframes([
            style({
                transform: 'translateX(0%)'
            })
          ])
        )
      ]),

      // route 'leave' transition
      transition(':leave', [
          style({
            transform: 'translateX(0%)'
          }),

          // animation and styles at end of transition
          animate('.5s ease-in-out', keyframes([
            style({
                transform: 'translateX(100%)'
            })
          ])
        )
      ])
  ]);